<div  class="container-fluid container-background">


  <!-- header row top bar contains title, menu, options -->
  <div class="row">

        <!-- affixed header box sets padding for right menu -->
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">

        <div class="outer">
        <div class="middle">

        <div *ngIf="error" class="error-general-overlay error-general-overlay-login">
            <div class="row">
                <div class="col-xs-12"><i class="fas fa-exclamation-triangle"></i> {{error.code}} {{error.msg}}</div>
            </div>
        </div>

        <div *ngIf="!error">

            <div *ngIf="validated && !completed">
                <div class="login-form-container">
                    <div class="login-header-title">
                        <i  class="zmdi zmdi-lock zdmi-fw"></i> Link with {{appName}}
                    </div>

                        <p>
                            {{appName}} will gain access to your Sync account with the following permissions:
                        </p>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <b>General</b>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr *ngIf="permissions.apACCOUNT">
                                    <td>
                                        Account Info
                                    </td>
                                    <td>
                                        This app can see your username and email.
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <b>Connected folders</b>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr *ngIf="permissions.apREAD">
                                    <td>
                                        Read
                                    </td>
                                    <td>
                                        This app can read the names and contents of files and folders.
                                    </td>
                                </tr>
                                <tr *ngIf="permissions.apWRITE">
                                    <td>
                                        Write
                                    </td>
                                    <td>
                                        This app can add or change files and folders.
                                    </td>
                                </tr>
                                <tr *ngIf="permissions.apSHARE">
                                    <td>
                                        Share
                                    </td>
                                    <td>
                                        This app can add other users to a folder.
                                    </td>
                                </tr>
                                <tr *ngIf="permissions.apLINK">
                                    <td>
                                        Link
                                    </td>
                                    <td>
                                        This app can create links to files or folders.
                                    </td>
                                </tr>
                        </table>
                        For more information on how to share your files through your Control Panel please visit <a href=helpLink target="_blank">our help page.</a>

                </div> <!-- login form conteiner -->

                <button
                    id="btn-auth-login"
                    (click)="oauthAllow()"
                    class="btn-block btn btn-primary btn-lg btn-oauth showhand">Allow</button>

                <button
                    *ngIf="user"
                    id="btn-auth-login"
                    (click)="oauthCancel()"
                    class="btn-block btn btn-primary btn-lg btn-oauth showhand">Cancel</button>
            </div>

            <div *ngIf="completed">
                <div class="login-form-container">
                    <div class="login-header-title">
                        <i  class="zmdi zmdi-lock zdmi-fw"></i> {{appName}} successfully linked!
                    </div>

                        {{appName}} can now access certain files and folders that you can make available through your control panel.
                        <p></p>
                        For more information on how to share your files through your Control Panel please visit <a href=helpLink target="_blank">our help page</a>.

                        Do not navigate away from this page, if you are not redirected please click "Continue"

                </div> <!-- login form conteiner -->
                <button
                    id="btn-auth-login"
                    (click)="finish()"
                    class="btn-block btn btn-secondary btn-lg btn-oauth showhand">Continue</button>
            </div>

        </div>

        </div> <!-- middle -->
        </div> <!-- outer -->


    </div>
    <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
          <!-- future -->

    </div>



  </div> <!-- row -->

  </div>
